import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import "../../../Styles/components/form-controls.scss";

export default function SearchField({
  className = "",
  onChange,
  placeholder = "Search",
  value = "",
  ...props
}) {
  return (
    <label className={["search-field", className].filter(Boolean).join(" ")}>
      <span className="search-field__icon" aria-hidden="true">
        <FontAwesomeIcon icon={faMagnifyingGlass} />
      </span>
      <input
        type="search"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        {...props}
      />
    </label>
  );
}
